import type {
  ElementState,
  singleElementState,
  DataExplorerState,
} from "@/types";

import { mutations } from "./mutations";
import { actions } from "./actions";
import { getters } from "./getters";

const elementSate: ElementState<any> = {
  data: [],
  error: null,
  loading: false,
};

const singleElementSate: singleElementState<any> = {
  data: [],
  error: null,
  loading: false,
};

export const dataExplorerState: DataExplorerState = {
  dashboards: elementSate,
  dashboard: singleElementSate,
  graph: singleElementSate,
  reportGraphs: elementSate,
  dashboardReport: singleElementSate,
};

export const DataExplorerModule = {
  namespaced: true,
  state: dataExplorerState,
  actions,
  mutations,
  getters,
};
